import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { UPDATE_CLASS_OBJECTIVE } from 'graphql/mutation/classe/updateClasseObjective';
import toast from 'react-hot-toast';
import { QUERY_CLASSE_INFO } from '../../../../graphql/query/classe/queryClasseInfos';
import ObjectiveUpdateView from './ObjectiveUpdate.view';

interface ObjectiveUpdateProps {
  nameObjective?: string | null;
  caObjective?: string | null;
  action: string;
  setShowObjective: (show: boolean) => void;
}

const ObjectiveUpdate = ({
  nameObjective = null,
  caObjective = null,
  action,
  setShowObjective
}: ObjectiveUpdateProps) => {
  const putAction = action === 'put';
  const [activeObjective, setActiveObjective] = useState({
    values: { name: nameObjective, ca: caObjective },
    errors: { name: false, ca: false },
    isValid: false
  });
  const [updateObjective, { loading, error }] = useMutation(
    UPDATE_CLASS_OBJECTIVE,
    {
      onCompleted: () => {
        toast.success(
          `Objectif de classe ${putAction ? 'modifié' : 'créé'} !`,
          {
            icon: '🎉'
          }
        );
      },
      onError: () => {
        toast.error("Erreur dans la mise à jour de l'objectif", {
          icon: '😕'
        });
      },
      refetchQueries: [{ query: QUERY_CLASSE_INFO }, 'getCurrentClasseInfos']
    }
  );

  const handleOnClick = () => {
    updateObjective({
      variables: {
        name: activeObjective.values.name,
        ca: parseInt(activeObjective.values.ca)
      }
    });
    setShowObjective(true);
  };

  if (loading) return <p>Mofification de l'objectif en cours...</p>;
  if (error) return <p>Erreur lors de la modification de l'objectif</p>;
  return (
    <ObjectiveUpdateView
      putAction={putAction}
      activeObjective={activeObjective}
      setActiveObjective={setActiveObjective}
      setShowObjective={setShowObjective}
      handleOnClick={handleOnClick}
    />
  );
};

export default ObjectiveUpdate;
